var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "all-chat" } }, [
    _c(
      "div",
      {
        staticClass: "d-flex w-100",
        staticStyle: { "background-color": "#ffffff" },
      },
      [
        _c(
          "div",
          { staticClass: "side-menubar-wrapper" },
          [
            _c("SideMenuBar", {
              attrs: {
                "selected-page": "reports",
                "selected-sub-page": "all-chats",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            { staticClass: "all-chat-container" },
            [
              _c(
                "div",
                { staticClass: "header" },
                [
                  _c("FilterTool", {
                    attrs: {
                      isGraphShowing: true,
                      "keep-state-on-query-params": true,
                    },
                    model: {
                      value: _vm.filters,
                      callback: function ($$v) {
                        _vm.filters = $$v
                      },
                      expression: "filters",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.loading
                ? _c(
                    "div",
                    {
                      staticClass:
                        "h-50 d-flex flex-column justify-content-center align-items-center text-align-center",
                    },
                    [
                      _c("a-spin"),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.graphData.length
                ? _c("LineGraphic", {
                    key: "" + _vm.renderKey,
                    attrs: {
                      graphData: _vm.graphData,
                      "total-data": _vm.totalData,
                      "avg-data": _vm.avgData,
                      timeSeriesType: _vm.timeSeriesType,
                      "sub-title": "allChats",
                    },
                  })
                : _c(
                    "div",
                    { staticClass: "d-flex justify-content-center mt-5" },
                    [
                      _c("ChartNotFound", {
                        attrs: { title: _vm.$t("message.dataNotFound") },
                      }),
                    ],
                    1
                  ),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }